module.exports = __webpack_public_path__ + "img/home.4f564629.png";